import React, { FC } from 'react';
import { Typography, Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ButtonProps } from '@mui/material/Button';
import { useTranslation } from 'react-i18next';

import { PrevIcon } from 'webPosApp/components/icons';

interface PrevButtonProps {
    buttonProps?: ButtonProps;
    title?: string;
}

const useStyles = makeStyles(() => {
    return {
        root: {
            height: '88px',
            minWidth: '360px !important',
        },
        icon: {
            marginRight: '92px',
        },
        label: {
            marginRight: '55px',
        },
    };
});

export const PrevButton: FC<PrevButtonProps> = ({ title, buttonProps }) => {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <Button
            classes={{
                startIcon: classes.icon,
                root: classes.root,
            }}
            startIcon={<PrevIcon colorType='secondary' />}
            variant='secondary'
            {...buttonProps}
        >
            <Typography className={classes.label} variant='button'>
                {title || t('Back')}
            </Typography>
        </Button>
    );
};
